var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEverRiseLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 24,
    viewBox: "0 0 178 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.177 7.28906H126.801V23.6749H131.177V7.28906Z",
    fill: "#2A488D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2751 4.75025V0.375H5.03335H0.65625V4.75025V9.83565V14.211V19.2964V23.6716H5.03335H18.2751V19.2964H5.03335V14.211H17.6702V9.83565H5.03335V4.75025H18.2751Z",
    fill: "#2A488D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M177.246 4.75025V0.375H164.004H159.629V4.75025V9.83565V14.211V19.2964V23.6716H164.004H177.246V19.2964H164.004V14.211H176.641V9.83565H164.004V4.75025H177.246Z",
    fill: "#2A488D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0563 0.398438H50.4375V4.77365H68.0563V0.398438Z",
    fill: "#FFCE53"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0563 19.3203H50.4375V23.6955H68.0563V19.3203Z",
    fill: "#FFCE53"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0563 9.85938H50.4375V14.2347H68.0563V9.85938Z",
    fill: "#FFCE53"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4715 18.1103L27.8158 0.421875H22.0898L31.5861 23.6721H37.4513L46.7603 0.421875H41.0361L34.4715 18.1103Z",
    fill: "#2A488D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.099 8.19475C92.099 4.05325 88.6291 0.695085 84.3502 0.695085L76.9629 0.671875H72.5859V4.87766V23.9703H76.9611V4.87766H81.3007H84.2913C84.7945 4.87766 85.2745 4.97755 85.7152 5.15245C87.1391 5.71985 88.1473 7.10805 88.1473 8.73365C88.1473 10.7643 86.577 12.4237 84.5875 12.5754C84.5286 12.5825 84.4697 12.5843 84.409 12.5861C84.3698 12.5879 84.3305 12.5897 84.2913 12.5897H81.3828V16.3957L87.7012 23.9257H93.357L86.6877 15.9817C89.8246 14.8451 92.099 11.5494 92.099 8.19475Z",
    fill: "#2A488D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M121.285 8.19475C121.285 4.05325 117.814 0.695085 113.536 0.695085L106.148 0.671875H101.773V4.87766V23.9703H106.148V4.87766H110.488H113.478C113.982 4.87766 114.462 4.97755 114.902 5.15245C116.326 5.71985 117.334 7.10805 117.334 8.73365C117.334 10.7643 115.764 12.4237 113.775 12.5754C113.716 12.5825 113.657 12.5843 113.596 12.5861C113.557 12.5879 113.518 12.5897 113.478 12.5897H110.57V16.3957L116.888 23.9257H122.545L115.875 15.9817C119.01 14.8451 121.285 11.5494 121.285 8.19475Z",
    fill: "#2A488D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M129.627 5.94815C131.128 5.59375 132.057 4.08975 131.703 2.58875C131.348 1.08785 129.844 0.158453 128.343 0.512873C126.842 0.867283 125.913 2.37125 126.267 3.87225C126.622 5.37315 128.126 6.30265 129.627 5.94815Z",
    fill: "#FFCE53"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M141.641 6.86115C141.641 5.51035 142.889 4.63245 145.089 4.63245C147.582 4.63245 150.222 5.40865 152.201 7.09845L155.097 3.51725C152.678 1.45635 149.452 0.375 145.565 0.375C139.809 0.375 136.288 3.48335 136.288 7.23225C136.288 15.7115 150.367 12.9744 150.367 16.8929C150.367 18.2097 149.011 19.3927 146.113 19.3927C142.741 19.3927 140.064 17.9742 138.34 16.3183L135.48 20.0672C137.789 22.196 141.163 23.6484 145.894 23.6484C152.457 23.6484 155.683 20.5401 155.683 16.42C155.684 8.01025 141.641 10.4084 141.641 6.86115Z",
    fill: "#2A488D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEverRiseLogo);
export default __webpack_public_path__ + "static/media/EverRiseLogo.d02e9efad40bf4de29e1a4e44c82247a.svg";
export { ForwardRef as ReactComponent };